export enum FishingSpotType {
	Reef = 1,
	Buoy = 2,
}

